import _ from "lodash";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

import { CandidateTypes } from "@/Components/common/client/candidates/CandidateTypes";
import { WorkedList } from "@/Components/common/client/candidates/Listing/WorkedList";
import {
  fetchWorkedCandidates,
  setWorkedCandidatesLoading,
  updatePagination,
  updateFilters,
  deSelectAllCandidate,
  updateListView,
} from "@/reducers/client_candidates/candidatesworked";
import { updateactivePages } from "@/reducers/clientcommon";
import useTitle from "@/utilities/hooks/useTitle";

/**
 * A function that handles the Worked component.
 *
 * @return {JSX.Element} the Worked component JSX
 */
const Worked = () => {
  useTitle("Worked Candidates");
  const { filters, pagination } = useSelector(
    (state) => state.clientCandidatesWorked,
  );
  const dispatch = useDispatch();
  const location = useLocation();
  useEffect(() => {
    const { state } = location;
    let filterObj = {};
    if (!_.isEmpty(state)) {
      filterObj = { ...filterObj, ...state };
      dispatch(updateFilters(filterObj));
    }
    dispatch(
      updatePagination({
        ...pagination,
        currentPage: 1,
        isLastPage: false,
      }),
    );
    dispatch(setWorkedCandidatesLoading(true));
    dispatch(deSelectAllCandidate());
    dispatch(fetchWorkedCandidates());
    dispatch(
      updateactivePages({
        activePage: "candidates",
        activeSubPage: "worked",
        callback: () => {
          if (!_.isEmpty(filterObj)) {
            dispatch(updateFilters(filterObj));
            if (filterObj["listView"]) {
              dispatch(updateListView(filterObj["listView"]));
            }
            window.history.pushState(
              {},
              document.title,
              window.location.pathname,
            );
          }
        },
      }),
    );
  }, []);
  return (
    <div className="flex flex-col gap-4">
      <CandidateTypes />
      <WorkedList />
    </div>
  );
};

export default Worked;
